import React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import ListSubheader from '@mui/material/ListSubheader';

const LocationsCardLoading = () => (
  <Card>
    <CardHeader
      avatar={(
        <Skeleton variant="circular" width={40} height={40} />
      )}
      title="Locations"
    />
    <CardContent>
      <List
        aria-label="horse current location"
      >
        <ListItemButton
          selected
        >
          <ListItemIcon><Skeleton variant="circular" width={40} height={40} /></ListItemIcon>
          <ListItemText
            primary={<Skeleton height={40} width={80} />}
            secondary={(
              <Skeleton height={20} width={200} />
            )}
          />
        </ListItemButton>
      </List>
      <Divider />
      <List
        aria-label="horse past locations"
        subheader={(
          <ListSubheader component="div" id="nested-list-subheader">
            Past or Future Locations
          </ListSubheader>
        )}
      >
        <ListItemButton
          disabled
        >
          <ListItemIcon><Skeleton variant="circular" width={40} height={40} /></ListItemIcon>
          <ListItemText
            primary={<Skeleton height={40} width={80} />}
            secondary={(
              <Skeleton height={20} width={200} />
            )}
          />
        </ListItemButton>
        <ListItemButton
          disabled
        >
          <ListItemIcon><Skeleton variant="circular" width={40} height={40} /></ListItemIcon>
          <ListItemText
            primary={<Skeleton height={40} width={80} />}
            secondary={(
              <Skeleton height={20} width={200} />
            )}
          />
        </ListItemButton>
      </List>
    </CardContent>
  </Card>
);

LocationsCardLoading.propTypes = { };

export default LocationsCardLoading;
